import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import {
    getDeviceType,
    getVersion,
    serviceErrorToAnalyticsFormat,
} from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';

class MyListActionFilter extends BaseActionFilter {
    getMyListPageDL(store, data) {
        const { context } = store.getState();
        const deviceType = getDeviceType(context);

        const getMyListDL = this.updateCommonDigitalData();
        getMyListDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        getMyListDL.page.pageInfo.pageType = 'my lists';
        getMyListDL.page.pageInfo.siteSection = 'account';
        getMyListDL.page.pageInfo.deviceType = deviceType;
        getMyListDL.page.pageInfo.searchRedirect = '';
        getMyListDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getMyListDL.page.pageInfo.version = getVersion('yoda account');
        getMyListDL.page.category = {};
        getMyListDL.page.category.primaryCategory = 'account';
        getMyListDL.page.category.subCategory1 = '';
        getMyListDL.page.category.subCategory2 = '';
        getMyListDL.page.category.department = 'account';
        getMyListDL.error = serviceErrorToAnalyticsFormat({}); // set empty error
        return getMyListDL;
    }
}

export default MyListActionFilter;
